module.exports = __webpack_public_path__ + "static/media/ice_cream.55a99002.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/homework-new/ice_cream.png
// module id = 634
// module chunks = 0